var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatosPersonalesHuella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_419",
    "data-name": "Grupo 419",
    transform: "translate(-858 -411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_41",
    "data-name": "Rect\\xE1ngulo 41",
    width: 40,
    height: 40,
    transform: "translate(858 411)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39",
    transform: "translate(445.519 -987.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(419.564 1398.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M445.234,1419.348a.61.61,0,0,1-.61-.612v-5.753a12.828,12.828,0,0,0-24.529-5.262.611.611,0,1,1-1.112-.505,14.05,14.05,0,0,1,26.863,5.767v5.753A.611.611,0,0,1,445.234,1419.348Z",
    transform: "translate(-418.927 -1398.93)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(418.987 1401.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M444.8,1420.733a2.309,2.309,0,0,1-1.472-.474,3.392,3.392,0,0,1-1.034-2.788c-.012-1.792-.155-6.083-.155-6.127a10.011,10.011,0,0,0-19.619-2.831.606.606,0,0,1-.061.141c-.085.143-.874,1.374-1.979,1.341-.687-.025-1.268-.505-1.729-1.428a.611.611,0,1,1,1.093-.546c.233.464.488.745.682.752.272-.017.668-.42.845-.687a11.233,11.233,0,0,1,21.989,3.237c0,.024.146,4.332.158,6.141a2.343,2.343,0,0,0,.566,1.833,1.579,1.579,0,0,0,1.348.132.611.611,0,1,1,.279,1.19A3.908,3.908,0,0,1,444.8,1420.733Z",
    transform: "translate(-418.689 -1400.092)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    transform: "translate(418.986 1404.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M444.655,1422.15a3.752,3.752,0,0,1-2.5-.925c-3.293-2.8-2.858-11.236-2.836-11.6a7.189,7.189,0,0,0-7.188-7.151,6.563,6.563,0,0,0-6.069,3.334c-.129.26-.265.546-.406.85-.9,1.926-2.018,4.32-3.924,4.915a3.327,3.327,0,0,1-2.742-.43.611.611,0,0,1,.617-1.054,2.144,2.144,0,0,0,1.761.316c1.391-.435,2.426-2.647,3.181-4.265.146-.313.284-.607.415-.876a7.773,7.773,0,0,1,7.166-4.014,8.421,8.421,0,0,1,8.409,8.41c0,.117-.422,8.22,2.407,10.631a2.712,2.712,0,0,0,2.5.539.613.613,0,0,1,.26,1.2A5.019,5.019,0,0,1,444.655,1422.15Z",
    transform: "translate(-418.689 -1401.254)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(418.987 1407.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M438.774,1418.509a.608.608,0,0,1-.44-.184c-1.909-1.972-1.85-9.481-1.838-10.328a4.367,4.367,0,0,0-4.364-4.356c-2.436,0-3.664,1.19-4.536,4.388a6.047,6.047,0,0,1-1.377,2.593,7.123,7.123,0,0,1-7.057,2.278.611.611,0,1,1,.277-1.19,5.918,5.918,0,0,0,5.865-1.9,4.885,4.885,0,0,0,1.1-2.054c1.022-3.754,2.732-5.338,5.729-5.338A5.593,5.593,0,0,1,437.72,1408c-.046,3.024.321,8.259,1.493,9.468a.611.611,0,0,1-.015.865A.6.6,0,0,1,438.774,1418.509Z",
    transform: "translate(-418.689 -1402.416)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    transform: "translate(418.986 1410.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M419.981,1414.846c-.231,0-.464-.005-.7-.015a.614.614,0,0,1-.588-.636.607.607,0,0,1,.639-.585c8.851.362,9.961-6.7,10.039-7.3a2.766,2.766,0,0,1,5.532.039.612.612,0,1,1-1.224,0,1.543,1.543,0,0,0-3.086,0l0,.071C430.576,1406.5,429.515,1414.846,419.981,1414.846Z",
    transform: "translate(-418.689 -1403.578)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(418.986 1413.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M419.3,1416.289a.612.612,0,0,1-.061-1.222c5.032-.5,8.6-2.027,10.612-4.538a7.292,7.292,0,0,0,1.673-4.983.612.612,0,1,1,1.214-.151,8.457,8.457,0,0,1-1.933,5.9c-2.222,2.778-6.073,4.456-11.445,4.99Z",
    transform: "translate(-418.689 -1404.859)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    transform: "translate(434.812 1422.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M434.711,1414.277c-5.515,0-9.2-4.408-9.366-4.612a.611.611,0,1,1,.945-.774c.041.048,4.1,4.886,9.75,4.067a.611.611,0,1,1,.177,1.21A10.423,10.423,0,0,1,434.711,1414.277Z",
    transform: "translate(-425.206 -1408.667)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(418.481 1420.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M419.093,1415.128a.612.612,0,0,1-.051-1.222c.107-.007,10.661-.935,13.453-5.772a.611.611,0,1,1,1.059.612c-3.113,5.391-13.951,6.343-14.41,6.379Z",
    transform: "translate(-418.481 -1407.828)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33",
    transform: "translate(434.044 1414.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M426.27,1411.51a.617.617,0,0,1-.483-.236c-1.581-2.035-.6-5.233-.556-5.369a.611.611,0,1,1,1.166.366c-.007.027-.83,2.724.357,4.25a.616.616,0,0,1-.107.86A.628.628,0,0,1,426.27,1411.51Z",
    transform: "translate(-424.89 -1405.478)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(419.314 1424.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M419.436,1416a.612.612,0,0,1-.073-1.219c.087-.012,8.966-1.129,13.116-5.116a.611.611,0,1,1,.847.881c-4.446,4.274-13.436,5.4-13.817,5.449Z",
    transform: "translate(-418.824 -1409.491)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35",
    transform: "translate(434.428 1426.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    d: "M435.306,1415.495a14.065,14.065,0,0,1-10.107-4.233.611.611,0,0,1,.918-.806,13.085,13.085,0,0,0,9.189,3.815.612.612,0,1,1,0,1.224Z",
    transform: "translate(-425.048 -1410.249)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(420.848 1428.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34",
    "data-name": "Trazado 34",
    d: "M441.312,1417.393c-.029,0-.058,0-.087-.005a18.813,18.813,0,0,1-9.883-4.8c-3.162,2.793-10.85,3.854-11.192,3.9a.611.611,0,0,1-.163-1.212c.085-.01,8.407-1.158,10.9-3.953a.615.615,0,0,1,.452-.2.637.637,0,0,1,.454.2,17.732,17.732,0,0,0,9.607,4.862.611.611,0,0,1-.087,1.217Z",
    transform: "translate(-419.456 -1411.118)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37",
    transform: "translate(422.89 1432.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35",
    "data-name": "Trazado 35",
    d: "M437.578,1417.449c-1.622,0-5.9-2.4-7.686-3.448-2.353,1.557-8.587,2.792-8.866,2.849a.613.613,0,0,1-.236-1.2c1.918-.377,7.215-1.622,8.672-2.846a.612.612,0,0,1,.7-.058c3,1.782,6.685,3.623,7.407,3.487a.617.617,0,0,1,.716.486.609.609,0,0,1-.478.714A1.155,1.155,0,0,1,437.578,1417.449Z",
    transform: "translate(-420.297 -1412.658)",
    fill: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(426.479 1436.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36",
    "data-name": "Trazado 36",
    d: "M433.056,1417.1a.6.6,0,0,1-.287-.073c-6.061-3.242-9.986-.507-10.027-.481a.611.611,0,0,1-.712-.993c.182-.134,4.59-3.2,11.314.4a.611.611,0,0,1-.289,1.151Z",
    transform: "translate(-421.775 -1414.21)",
    fill: "#a7a7a7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatosPersonalesHuella);
export default __webpack_public_path__ + "static/media/datos-personales-huella.3f916e663902289b184ee370e281db34.svg";
export { ForwardRef as ReactComponent };